import { useRef } from 'react'

import { HomeFilled } from '@ant-design/icons'
import { Divider, Layout, Typography } from 'antd'
import { createStyles } from 'antd-style'

import { PageSider } from '@eastcoal/common/components/Layout/PageSider'
import { system } from '@eastcoal/common/config/system'

import { RouterLink } from '@eastcoal/router/components/Link'
import { RouterOutlet } from '@eastcoal/router/components/Outlet'
import { SiderMenu } from '@eastcoal/router/components/SiderMenu'
import { EastcoalLogo } from '@eastcoal/shared/components/EastcoalLogo'
import { GlobalHeader } from '@eastcoal/shared/components/GlobalHeader'

import { ConsoleLayoutContext } from './context'

const useStyles = createStyles(({ prefixCls, token }) => ({
  container: {
    height: '100vh',
    overflow: 'hidden'
  },
  globalHeader: {
    paddingInline: token.paddingMD
  },
  pageHeader: {
    position: 'relative',
    zIndex: token.zIndexPopupBase,
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
    height: 64,
    paddingInline: token.paddingMD,
    backgroundColor: token.colorBgBase,
    boxShadow: `0px 4px 4px 0px rgba(0,50,184,0.1)`
  },
  homeLinkIcon: {
    marginRight: token.marginXS
  },
  logoDivider: {
    height: '2em',
    borderColor: token.colorBorder,
    marginInline: token.marginMD
  },
  menu: {
    [`& .${prefixCls}-menu-item`]: {
      borderTopLeftRadius: 20,
      borderTopRightRadius: 0,
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 20
    },
    [`& .${prefixCls}-menu-item-selected`]: {
      backgroundColor: token.colorPrimary,
      color: token.colorWhite
    },
    [`& a`]: {
      transition: 'none'
    }
  },
  main: {
    position: 'relative',
    height: '100%',
    overflow: 'auto'
  },
  // 多包一层，防止 main 的 padding 会影响到子元素的 sticky 定位
  content: {
    height: '100%',
    paddingInline: token.paddingSM,
    paddingBlock: token.paddingXS,
    ['.page-container-breadcrumb']: {
      paddingBlockEnd: token.paddingXS
    }
  }
}))

/**
 * 管理系统风格的布局
 */
export const ConsoleLayout = () => {
  const ref = useRef<HTMLDivElement>(null)
  const { styles } = useStyles()

  return (
    <ConsoleLayoutContext value={{ ref }}>
      <Layout className={styles.container}>
        <GlobalHeader showMallCenter className={styles.globalHeader}>
          <RouterLink to={system.router.mallBaseUrl}>
            <HomeFilled className={styles.homeLinkIcon} />
            <span>前往商城首页</span>
          </RouterLink>
        </GlobalHeader>
        <Layout.Header className={styles.pageHeader}>
          <EastcoalLogo link='/' />
          <Divider className={styles.logoDivider} orientation='vertical' />
          <Typography.Text>会员中心</Typography.Text>
        </Layout.Header>
        <Layout hasSider>
          <PageSider>
            <SiderMenu className={styles.menu} />
          </PageSider>
          <Layout.Content ref={ref} className={styles.main}>
            <div className={styles.content}>
              <RouterOutlet />
            </div>
          </Layout.Content>
        </Layout>
      </Layout>
    </ConsoleLayoutContext>
  )
}
